/// Compact wind readout in the chrome — the small box with the
/// rotating arrow + degree readout that makes the live wind sim
/// visible to the player. Drives runway-selection decisions
/// (Cleared to land picks the wind-favored end), so the player
/// can preempt a runway switch before it happens.
///
/// The arrow points in the direction the wind is blowing TO
/// (so for "wind 270°" — wind FROM the west — the arrow points
/// east, matching how aviation weather reports are read).
///
/// Sits at top-left under the score block so the chrome stack
/// reads top-to-bottom: toolbar → score → distance/ETA → wind.

import type { WindState } from '../state/store'

export function WindIndicator(props: { wind: WindState }) {
  // The windsock arrow visually shows where the wind is going.
  // CSS rotation is clockwise from 12 o'clock. Wind direction in
  // aviation is the heading FROM which the wind is blowing, so
  // the arrow needs to point in the OPPOSITE compass direction:
  // wind 270° (from west) → arrow points east → CSS rotate(90°).
  const arrowRotation = (props.wind.directionDeg + 180) % 360
  return (
    <div className="flex items-center gap-1.5 rounded-md bg-slate-900/70 px-2 py-1 text-[11px] font-medium text-white/85 shadow ring-1 ring-white/10 md:text-xs">
      <span className="text-slate-400">🌬</span>
      <span
        className="inline-block leading-none text-emerald-300"
        style={{ transform: `rotate(${arrowRotation}deg)` }}
        aria-hidden="true"
      >
        ↑
      </span>
      <span className="font-mono text-slate-200">
        {String(props.wind.directionDeg).padStart(3, '0')}°
      </span>
      <span className="font-mono text-slate-400">
        / {props.wind.speedKts}kt
      </span>
    </div>
  )
}
